<template>
  <v-snackbar :class="`${colorClass}`" v-model="showSnackbar" :timeout="-1" variant="outlined" location="bottom center"
    :min-height=48 :min-width=427 :max-width="isDetailed ? 387 : null">
    <VRow
      :align="isDetailed ? 'start' : 'center'"
      :class="`${isDetailed ? 'padding-top_sm' : ''} ${
        isDetailed && (buttonText || ghostButtonText) ? 'padding-bottom_sm' : ''
      } ${title ? 'py-2' : ''}`"
    >

      <!--Leading Icon-->
      <div v-if="icon !== 'check'" :class="`${iconClass}
        height_md
        width_md
        border_rounded_full
        margin-left_sm
        margin-right_xs-df
        bold-subtitle-sm`"
      >
        {{ icon }}
      </div>
      <div v-else :class="`${iconClass}
        height_md
        width_md
        border_rounded_full
        margin-left_sm
        margin-right_xs-df`">
        <SvgFactory name="icon_check_simple2" :width=13 customColor="#FFFFFF" />
      </div>
      <!--END Leading Icon-->

      <!--Message Body-->
      <div class="d-flex flex-column">
        <span
          v-if="title"
          :style="{ maxWidth: '200px'}"
          :class="`${
            isDetailed ? 'iconn-snackbar-truncate-text' : ''
          } text-truncate regular-body-sm typography_default marign-right_xs-df`"
          ><b>{{ title }}</b></span
        >
        <span
          :class="`${isDetailed ? 'iconn-snackbar-truncate-text' : ''}
        regular-body-sm
        typography_default
        marign-right_xs-df`"
          v-html="boldSubstring(message)"
        ></span>
      </div>
      <!--END Message Body-->

      <VRow justify="end" align="center" class="padding-top_sm padding-bottom_sm">
        <!--Button-->
        <div
          v-if="buttonText && !isDetailed"
          class="iconn-snackbar-button height_lg border_stroke_sm_df medium-body-sm typography_default border_rounded_md_df"
          @click="handleButtonClick"
          @keydown="handleButtonClick"
        >
          {{ buttonText }}
        </div>
        <!--END Button-->

        <!--Close Button-->
        <div
          class="text-right"
          style="margin-left: 12px; padding-left:6px; padding-right: 24px; cursor: pointer;"
          @click="showSnackbar = false"
          @keydown="showSnackbar = false"
        >
          <SvgFactory name="icon_close" :width=15 color="#64748B" />
        </div>
        <!--END Close Button-->

      </VRow>
    </VRow>

    <!--Bottom Row for detailed Snackbar-->
    <VRow
      v-if="isDetailed"
      justify="end"
      align="center"
      class="padding-bottom_sm padding-right_sm"
    >
      <div
        v-if="ghostButtonText"
        class="iconn-snackbar-button--ghost height_lg border_stroke_sm_df medium-body-sm border_rounded_md_df margin-right_xs-df"
        @click="handleGhostButtonClick"
        @keydown="handleGhostButtonClick"
      >
        {{ ghostButtonText }}
      </div>
      <div
        v-if="buttonText"
        class="iconn-snackbar-button height_lg border_stroke_sm_df medium-body-sm typography_default border_rounded_md_df"
        @click="handleButtonClick"
        @keydown="handleButtonClick"
      >
        {{ buttonText }}
      </div>
    </VRow>
  </v-snackbar>
</template>

<script>
import SvgFactory from '@design_system_v2/atoms/SvgFactory.vue';

export default {
  name: 'SnackbarAtom',
  components: {
    SvgFactory,
  },
  data() {
    return {
      showSnackbar: false,
      message: '',
      title: '',
      type: '',
      colorClass: '',
      icon: '',
      iconClass: '',
      buttonText: '',
      buttonClick: null,
      ghostButtonText: '',
      ghostButtonClick: null,
      isDetailed: false,
      boldText: '',
      timeout: 0,
    };
  },
  methods: {
    show(data) {
      this.message = data.message;
      this.title = data.title;
      this.showSnackbar = true;
      this.type = data.type;
      this.buttonText = data.buttonText;
      this.buttonClick = data.buttonClick;
      this.ghostButtonText = data.ghostButtonText;
      this.ghostButtonClick = data.ghostButtonClick;
      this.isDetailed = data.isDetailed;
      this.boldText = data.boldText;
      this.timeout = data.timeout || 2000;
      switch (data.type) {
        case 'info':
          this.colorClass = 'iconn-snackbar-color--info';
          this.icon = '?';
          this.iconClass = 'iconn-snackbar-icon--info';
          break;
        case 'warning':
          this.colorClass = 'iconn-snackbar-color--warning';
          this.icon = '!';
          this.iconClass = 'iconn-snackbar-icon--warning';
          break;
        case 'error':
          this.colorClass = 'iconn-snackbar-color--error';
          this.icon = '!';
          this.iconClass = 'iconn-snackbar-icon--error';
          break;
        case 'success':
          this.colorClass = 'iconn-snackbar-color--success';
          this.icon = 'check';
          this.iconClass = 'iconn-snackbar-icon--success';
          break;
        default:
          this.colorClass = 'iconn-snackbar-color--default';
          this.icon = '?';
          this.iconClass = 'iconn-snackbar-icon--default';
          break;
      }

      setTimeout(() => {
        this.showSnackbar = false;
      }, this.timeout);
    },
    handleButtonClick() {
      this.showSnackbar = false;
      this.buttonClick();
    },
    handleGhostButtonClick() {
      this.showSnackbar = false;
      this.ghostButtonClick();
    },

    boldSubstring(str) {
      if (!this.boldText || this.boldText === '') return str;
      const regex = new RegExp(this.boldText, 'gi');
      const bold = str.replace(
        regex,
        `<b>${this.boldText}</b>`,
      );

      return bold;
    },
  },
};
</script>

<style lang="scss">
@import "@foundation";

.iconn-snackbar-color {
  &--info {
    color: map-get($secondary, "blue-500");
  }

  &--warning {
    color: map-get($warning, "orange-500");
  }

  &--error {
    color: map-get($error, "red-500");
  }

  &--success {
    color: map-get($success, "green-600");
  }

  &--default {
    color: map-get($neutral, "neutral-300");
  }
}

.iconn-snackbar-icon {
  &--info {
    display: flex;
    justify-content: center;
    align-items: center;
    @extend .border_stroke_md;
  }

  &--warning {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: map-get($warning, "orange-500") !important;
    color: map-get($basic, "white");
  }

  &--error {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: map-get($error, "red-600") !important;
    color: map-get($basic, "white");
  }

  &--success {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: map-get($success, "green-500") !important;
  }

  &--default {
    display: flex;
    justify-content: center;
    align-items: center;
    border-color: map-get($neutral, "neutral-500");
    color: map-get($neutral, "neutral-500");
    @extend .border_stroke_md;
  }
}

.v-snackbar__wrapper {
  @extend .gray-shadow-md;
}

.v-snackbar--variant-outlined {
  background-color: map-get($basic, "white") !important;
}

.iconn-snackbar-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9.5px 24px;
  border-color: map-get($secondary, "blue-500");

  &--ghost {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9.5px 24px;
    border-color: transparent;
    color: map-get($secondary, "blue-600");
  }
}

.iconn-snackbar-truncate-text {
  max-width: 283px;
}
</style>
